import { combineReducers } from 'redux';
import displayBoardReducer from './displayboard/reducer';

const appReducer = combineReducers({
    displayBoardReducer
});
const rootReducer = (state, action) => {
    return appReducer(state, action)
}
export default rootReducer;